/**
 * Aviso de sucesso global, discreto (um de cada vez): só é chamado DEPOIS que a API
 * confirmou a gravação. A área que mostra o aviso fica no AppShell (`NoticeArea`).
 */
import { useSyncExternalStore } from "react";

export type Notice = { id: number; message: string };

let current: Notice | null = null;
let seq = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** Mostra "… com sucesso." (substitui o aviso anterior, se houver). */
export function notifySuccess(message: string) {
  seq += 1;
  current = { id: seq, message };
  emit();
}

/** Fecha o aviso (só se ainda for o mesmo, quando `id` é informado). */
export function clearNotice(id?: number) {
  if (id !== undefined && current?.id !== id) return;
  current = null;
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useNotice(): Notice | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null,
  );
}
